<nav class="navbar navbar-expand-lg navbar-light bg-light shadow-sm" style="height: 150px">
  <div class="container">
    <!-- Brand -->
    <img src="assets/images/NBHA-Norway.png" alt="logo" style="height: 150px; width: auto; margin-right: 50px;" />

    <!-- Mobile Toggle -->
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Menu -->
    <div class="collapse navbar-collapse" id="navbarNav" #navbarCollapse>
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item me-3 f-20 fw-bold"><a class="nav-link" routerLink="/" (click)="closeMobileMenu()">Home</a></li>
        <li class="nav-item me-3 f-20 fw-bold"><a class="nav-link" routerLink="/shows" (click)="closeMobileMenu()">Shows</a></li>
        <li class="nav-item me-3 f-20 fw-bold"><a class="nav-link" routerLink="/results" (click)="closeMobileMenu()">Results</a></li>
        <li class="nav-item me-3 f-20 fw-bold"><a class="nav-link" routerLink="/news" (click)="closeMobileMenu()">News</a></li>
        <li class="nav-item me-3 f-20 fw-bold"><a class="nav-link" routerLink="/membership" (click)="closeMobileMenu()">Membership</a></li>
        <li class="nav-item me-3 f-20 fw-bold"><a class="nav-link" routerLink="/rulebook" (click)="closeMobileMenu()">Rulebook</a></li>
        <li class="nav-item me-3 f-20 fw-bold"><a class="nav-link" routerLink="/about" (click)="closeMobileMenu()">About</a></li>
      </ul>

      <!-- Right side -->
      <div class="d-flex align-items-center">
        <!-- If NOT logged in -->
<!--        @if (!isAuthenticated) {-->
<!--          <button-->
<!--            class="btn btn-primary"-->
<!--            routerLink="/auth/login"-->
<!--            style="background-color: #19226d"-->
<!--          >-->
<!--            Login-->
<!--          </button>-->
<!--        }-->

        <!-- If logged in -->
<!--        @if (isAuthenticated && userObj) {-->
<!--          <div class="app-navbar flex-shrink-0">-->
<!--            @if (companies) {-->
<!--              <div class="app-navbar-item ms-1 ms-lg-3" >-->
<!--                <div-->
<!--                  class="btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-175px h-35px overflow-hidden text-truncate d-flex align-items-center justify-content-between"-->
<!--                  data-kt-menu-trigger="{default: 'click', lg: 'hover'}"-->
<!--                  data-kt-menu-attach="parent"-->
<!--                  data-kt-menu-placement="bottom-end"-->
<!--                >-->
<!--                <span-->
<!--                  class="text-truncate flex-grow-1 me-2"-->
<!--                  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"-->
<!--                >-->
<!--                  {{ storageService.getSelectedCompany().entity_name }}-->
<!--                </span>-->
<!--                  <i class="fa far fs-2x fa-building flex-shrink-0"></i>-->
<!--                </div>-->
<!--                <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-semibold py-4 fs-6 w-225px" data-kt-menu="true">-->
<!--                  <app-header-company-select-->
<!--                    [companies]="companies"-->
<!--                  />-->
<!--                </div>-->
<!--              </div>-->
<!--            }-->
<!--            <div class="dropdown ms-3">-->
<!--              <a-->
<!--                class="d-flex align-items-center text-decoration-none dropdown-toggle"-->
<!--                id="profileDropdown"-->
<!--                role="button"-->
<!--                data-bs-toggle="dropdown"-->
<!--                aria-expanded="false"-->
<!--              >-->
<!--                <img-->
<!--                  [src]="userObj.profile_image_url || 'assets/media/avatars/300-1.jpg'"-->
<!--                  alt="profile"-->
<!--                  class="rounded-circle border"-->
<!--                  width="60"-->
<!--                  height="60"-->
<!--                />-->
<!--              </a>-->
<!--              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="profileDropdown">-->
<!--                <li><a class="dropdown-item" routerLink="/user-profile">Profile Page</a></li>-->
<!--                <li><a class="dropdown-item" routerLink="/horses">Horses</a></li>-->
<!--                <li><a class="dropdown-item" routerLink="/shows">Shows</a></li>-->
<!--                <li><a class="dropdown-item" routerLink="/results">Results</a></li>-->
<!--                <li><hr class="dropdown-divider"></li>-->
<!--                <li>-->
<!--                  <button class="dropdown-item text-danger" (click)="onSignOut()">Sign Out</button>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
<!--        }-->
      </div>
    </div>
  </div>
</nav>
